import {
  LOAD_PHP_CONFIGS,
  LOAD_PHP_CONFIGS_FAIL,
  LOAD_PHP_CONFIGS_SUCCESS,
  LoadPhpConfigs,
  LoadPhpConfigsFail,
  LoadPhpConfigsSuccess
} from '../actions/hosting-php-configs.action';
import {PhpConfigsAction} from "../actions";

export interface IHostingEntityState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IPhpConfigsState {
  entities: {[websiteId: number]: IHostingEntityState};
}

export const initialState: IPhpConfigsState = {
  entities: {}
};

export function reducer(state: IPhpConfigsState = initialState, action: PhpConfigsAction): IPhpConfigsState {
  let payload: any;

  switch (action.type) {

    case LOAD_PHP_CONFIGS:
      payload = (<LoadPhpConfigs>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };
    case LOAD_PHP_CONFIGS_SUCCESS:
      payload = (<LoadPhpConfigsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_PHP_CONFIGS_FAIL:
      payload = (<LoadPhpConfigsFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
